export const apiBaseUrls = {
    Local: "https://localhost:7222/",
    Staging: "https://mfptest.uky.edu/api/",
    Production: "https://mfp.uky.edu/api/"
};

export const resolveApiBaseUrl = (currentUrl = window.location.href) => {
    if (currentUrl.includes("localhost")) {
        return apiBaseUrls.Local;
    }

    if (currentUrl.includes("mfptest")) {
        return apiBaseUrls.Staging;
    }

    return apiBaseUrls.Production;
};
